/**
|--------------------------------------------------
| THIS COMPONENT HAS REBUILD on 1-april-2019
|--------------------------------------------------
*/

import React from 'react';
import moment from 'moment';
import Presenter from '../../../presenter.js'
import RequestProperties from '../../request.props.js';
import DateRangePicker from 'react-daterange-picker';
import classnames from 'classnames';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink } from 'reactstrap';

// Component
import TabTracking from '../Tab/TabTracking.js';
import TabMaintenance from '../Tab/TabMaintenance.js';
import TabPurchase from '../Tab/TabPurchase.js';
import TabNotes from '../Tab/TabNotes.js';
import NoAssetImage from '../../../../../views/assets/global/img/no-asset-image.jpg';
import Logo from '../../../../../views/assets/global/img/AssetVault_logo_80.jpg';
import Module from '../../../../../utils/Render.js';
// import {ButtonValidation, ButtonCancel} from '../../../../../component/Button.js';

// TOAST
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

import Gallery from 'react-fine-uploader'
import 'react-fine-uploader/gallery/gallery.css'
import QRCode from '../../../../../qrreader/helper/component/QRGenerator.js';
// const QRCode = require('qrcode-react')

// import OwlCarousel from 'react-owl-carousel';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactImageMagnify from 'react-image-magnify';

const SliderSetting = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
}


let stateDefinitions = {
  available: {
    selectable: false,
    color: null,
    label: 'Available',
  },
  unavailable: {
    selectable: false,
    color: '#78818b',
    label: 'Not available',
  },
  yours: {
    selectable: false,
    color: '#ffd200',
    label: 'Your booking',
  }
};

export default class ModalDetailAsset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      SelectedItem : null,
      value        : null,
      activeTab    : '1',
      overflow     : 'hidden',
      UserToken    : this.props.UserReducer.token,
      UserReducer  : this.props.UserReducer,
      disabledBook : this.props.disableBook,
      dateRanges   : [],
      imgUploadBox : false,
      docUploadBox : false
    }
    this.selected 		= null;
    this.assetOwner 	= false;
    this.toggleTab 		= this.toggleTab.bind(this);
    this.handleSelect 	= this.handleSelect.bind(this);

    this.uploader = Module.Uploader(
      this.props.UserReducer,
      null,
      this.onUploadSuccess,
      this.onUploadFailed,
    )
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  onUploadSuccess(name){
    toast.success("File " + name + " uploaded successfully")
  }

  onUploadFailed(errorText){
    toast.error(errorText)
  }

  handleSelect(range, states) {
    if (range.end - range.start > 1000 * 60 * 60 * 24 * this.state.SelectedItem.MaxDay){
      toast.error('Maximum book duration is ' + this.state.SelectedItem.MaxDay + ' day(s)')
      this.setState({disabledBook : true});
    } else {
      this.setState({disabledBook : false});
    }
    this.setState({
      value: range,
      states: states,
      disabledBook: this.state.disabledBook,
    })
  }

  loadMasterReservation(alias) {
    Presenter.ReadMasterReservation(
      RequestProperties.ReadMasterReservation("Read", this, this.ReadMasterSuccess, this.ReadMasterFailed, alias)
    )
  }

  ReadMasterSuccess(params, response) {
    let booklist = [];
    for(let i = 0; i < response.data.length; i++){
      let bookstate = 'unavailable';
      if (response.data[i].User.Username === params.self.state.UserReducer.username) {
        bookstate = 'yours';
      }
      booklist.push({
        'state': bookstate,
        'range': moment.range(
          moment(response.data[i].StartDate),
          moment(response.data[i].FinishDate)
        )
      })
    }

    params.self.setState({
      dateRanges: booklist,
      disabledBook: true
    })
  }

  ReadMasterFailed(response) {

  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.ActiveTabNotes){
      this.setState({activeTab:'3'});
    } else {
      this.setState({activeTab:'1'});
    }

    if(nextProps.isUpdateReservation) {
      let booklist = [];
      booklist.push({
        'state': 'yours',
        'range': moment.range(
          moment(nextProps.dateBookingStart_UTC).format('YYYY-MM-DD'),
          moment(nextProps.dateBookingEnd_UTC).format('YYYY-MM-DD'),
        )
      })
      this.setState({
        value: null,
        dateRanges: [...this.state.dateRanges, ...booklist]
      })
      nextProps.setIsUpdateReservation(false)
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.selectedItem !== null ){
      nextState.SelectedItem = nextProps.selectedItem;
      this.assetOwner        = nextProps.selectedItem.Owner.Username === nextProps.UserReducer.username
      this.uploader.methods._options.request.tempParams.Asset = nextProps.selectedItem.Alias

      if (nextState.SelectedItem.Alias !== this.selected){
        if (nextState.SelectedItem.IsInternalAsset){
          this.loadMasterReservation(nextState.SelectedItem.Alias);
        }
        this.selected = nextState.SelectedItem.Alias;
        nextState.value = null;
      }
      stateDefinitions.available.selectable = nextState.SelectedItem.CanBook
      return true;

    }
    return false;
  }

  willMount(){
    this.setState({
      disabledBook : this.props.disabledBook
    })
  }

  RenderImage() {
    let imageList = [];
    let image = this.state.SelectedItem.Photos.results;
    if(image.length === 0) {
      return (<img className="img-null-owl" src={NoAssetImage} alt="Loading"/>)
    } else {
      for(let i = 0; i < image.length; i++){
        imageList.push(
          <ReactImageMagnify key={i} 
            {...{
              smallImage: {
                  alt: image[i].Alias,
                  isFluidWidth: true,
                  src: `${image[i].URL}&token=${this.state.UserToken}`,
                  width: 300,
                  height: 450
              },
              largeImage: {
                  src: `${image[i].URL}&token=${this.state.UserToken}`,
                  width: 1200,
                  height: 1800
              },
              enlargedImageContainerDimensions: {
                  width: '200%',
                  height: '100%'
              },
              enlargedImagePosition: "over",
              className:"img-responsive-slick",
              isHintEnabled: true,
            }}
          />
        )
      }
    }
    return imageList;
  }

  renderReservationField(clsName){
    return(
      <div className={classnames("col-md-12", {[clsName] : this.props.isFromQR})}>
        <div className="list-separator">
          <div className="item-inner">Reservation</div>
        </div>
        <DateRangePicker
          firstOfWeek={1}
          numberOfCalendars={1}
          selectionType='range'
          minimumDate={new Date()}
          stateDefinitions={stateDefinitions}
          dateStates={this.state.dateRanges}
          defaultState="available"
          showLegend={true}
          value={this.state.value}
          onSelect={this.handleSelect}
        />
        {this.props.mode !== 'booked' &&
          <button className={this.state.disabledBook? 'btn btn-block btn-default' : 'btn btn-block btn-primary'} onClick={()=>this.props.toggleModalBooking(this.state.value)} disabled={this.state.disabledBook}>Book Now</button>
        }
        <div className="cell-spacer"></div>
      </div>
    )
  }

  renderUploadField(clsName){
    return(
      <div
        className={classnames('isRepeatBox', 'white', {
          open: this.state.docUploadBox,
          [clsName] : this.props.isFromQR
        })}
        style={{
          'overflow': this.state.overflow,
          'marginBottom':0
        }}
      >
      <div className="list-separator">
        <div className="item-inner">Upload Documents / Images</div>
      </div>
      <div className="m-top-15"></div>
        <div className="form-group">
      <Gallery uploader={this.uploader} />
        </div>
      </div>
    )
  }

  renderDetailInformation(){
    return(
      <div className="row hidden-lg-up">
        <div className="col-6 list-border-bottom">
          <ListGroup>
            <ListGroupItem className="no-border no-padding-top list-qrcode">
              <div className="col-12">
                <strong className="spaceRRR">Status</strong>
              </div>
              <div className="col-12">
                <span>{this.state.SelectedItem.Status.Name}</span>
              </div>
            </ListGroupItem>
          </ListGroup>
        </div>
        <div className="col-6 list-border-bottom">
          <ListGroup>
            <ListGroupItem className="no-border no-padding-top list-qrcode">
              <div className="col-12">
                <strong className="spaceRRR">Assigned</strong>
              </div>
              <div className="col-12">
                <span>{this.state.SelectedItem.Owner.FirstName}{' ' + this.state.SelectedItem.Owner.LastName}</span>
              </div>
            </ListGroupItem>
          </ListGroup>
        </div>
        <div className="col-6 list-border-bottom">
          <ListGroup>
            <ListGroupItem className="no-border list-qrcode">
              <div className="col-12">
                <strong className="spaceRRR">Location</strong>
              </div>
              <div className="col-12">
                <span>{this.state.SelectedItem.Location.Name}</span>
              </div>
            </ListGroupItem>
          </ListGroup>
        </div>
        <div className="col-6 list-border-bottom">
          <ListGroup>
            <ListGroupItem className="no-border list-qrcode">
              <div className="col-12">
                <strong className="spaceRRR">Site</strong>
              </div>
              <div className="col-12">
                <span>{this.state.SelectedItem.Site.Name}</span>
              </div>
            </ListGroupItem>
          </ListGroup>
        </div>
      </div>
    )
  }

  renderActionButton(clsName){
    const confirmation   = this.state.SelectedItem.Confirmation
    const move         	 = this.assetOwner && (!confirmation || confirmation.Response != null)
    const extend       	 = this.state.SelectedItem.Tracking.DueDate && move
    const isAdmin        = this.props.UserReducer.props.isAdmin
    const buttonReassign = () => {
      if (this.assetOwner){
        if (!confirmation || (confirmation.Response !== null)){
          return([
            <div key={0} className="col-md-3 m-top-15">
              <button className={'btn btn-block btn-primary'} onClick={() => this.props.openModalReassign(this.state.SelectedItem)}>Re-assign</button>
            </div>,
            <div key={1} className="col-md-3 m-top-15">
              <button
                className={'btn btn-block btn-primary'}
                onClick={() => this.props.openModalQRReassign(this.state.SelectedItem.Alias)}
              >Re-assign by QR</button>
            </div>
          ])
          }else {
            return(
              <div className="col-md-3 m-top-15">
                <button
                  className={'btn btn-block btn-info'}
                  onClick={() => this.props.cancelReassign(this.state.SelectedItem)}
                >Cancel Re-Assign
                </button>
              </div>
            )
          }
      }else{
        if(confirmation){
          const toUser = confirmation.ToUser
          const currentUser = this.props.UserReducer.username
          if(currentUser === toUser && confirmation.Response === null){
            return([
              <div key={0} className="col-md-3 m-top-15">
                <button
                  className={'btn btn-block btn-success'}
                  onClick={() => this.props.confirm(true, confirmation)}
                >Accept Reassign
                </button>
              </div>
              ,
              <div key={1} className="col-md-3 m-top-15">
                <button
                  className={'btn btn-block btn-danger'}
                  onClick={() => this.props.confirmAction(false, confirmation)}
                >Reject Reassign
                </button>
              </div>
            ])
          }
        }
        return(
          <div className="col-md-3 m-top-15">
            <button className={'btn btn-block btn-default'} disabled>Re-Assign</button>
          </div>
        )
      }
    }

    return (
      <div className={clsName}>
        <div className="col-md-12">
            <div className="list-separator"><div className="item-inner">Action</div></div>
        </div>
        <div className="col-md-12">
          <div className="row justify-content-md-center">
            {buttonReassign()}
            <div className="col-md-3 m-top-15">
              <button
                className={move ? 'btn btn-block btn-warning' : 'btn btn-block btn-default'}
                disabled={!move}
                onClick={() => this.props.openModalMoveAsset(this.state.SelectedItem)}
              >Move</button>
            </div>
            <div className="col-md-3 m-top-15">
              <button
                className={extend ? 'btn btn-block btn-success' : 'btn btn-block btn-default'}
                disabled={!extend}
                onClick={() => this.props.openModalExtend(this.state.SelectedItem)}
              >Extends</button>
            </div>
            <div className="col-md-3 m-top-15">
              <button
                className={ this.assetOwner ? 'btn btn-block btn-danger' : 'btn btn-block btn-default'}
                disabled={!this.assetOwner}
                onClick={() => this.props.openModalReqMaintenance()}
              >Request Maintenance</button>
            </div>
              <div className="col-md-3 m-top-15">
                <button
                  className={ this.assetOwner ? 'btn btn-block btn-danger' : 'btn btn-block btn-default'}
                  disabled={!this.assetOwner}
                  onClick={() => this.props.toggleModalProblem()}
                >Report Problem</button>
            </div>
            <div className="col-md-4 hidden-lg-up m-top-15">
              <button
                className={isAdmin ? 'btn btn-block btn-success' : 'btn btn-block btn-default'}
                disabled={!isAdmin}
                onClick={() => this.setState({ docUploadBox: !this.state.docUploadBox })}
              >Upload Documents / Images</button>
              {this.props.isFromQR ? this.renderUploadField('hidden-lg-up m-top-15') : null}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderDetailTab(){
    if(!this.props.isFromQR){
      if(this.state.SelectedItem.IsInternalAsset){
        return(
          <div className="row">
            <div className="col-md-12 m-top-15">
              <Nav tabs>
                <NavItem>
                  <NavLink className={classnames({ active: this.state.activeTab === '1' })} onClick={() => { this.toggleTab('1'); }} >
                    Tracking
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: this.state.activeTab === '2' })} onClick={() => { this.toggleTab('2'); }} >
                    Maintenance
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: this.state.activeTab === '3' })} onClick={() => { this.toggleTab('3'); }} >
                    Notes
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: this.state.activeTab === '4' })} onClick={() => { this.toggleTab('4'); }} >
                    Purchase
                  </NavLink>
                </NavItem>
              </Nav>
              
              <TabContent className="" activeTab={this.state.activeTab}>
                <TabPane tabId="1">
                  <div className="">
                    <TabTracking UserReducer={this.state.UserReducer} SelectedItem={this.state.SelectedItem}></TabTracking>
                  </div>
                </TabPane>

                <TabPane tabId="2">
                  <div className="">
                    <TabMaintenance UserReducer={this.state.UserReducer} SelectedItem={this.state.SelectedItem}></TabMaintenance>
                  </div>
                </TabPane>

                <TabPane tabId="3">
                  <div className="">
                    <TabNotes
                      active             ={this.state.activeTab === "3" ? true : false}
                      UserReducer        ={this.state.UserReducer}
                      SelectedItem       ={this.state.SelectedItem}
                  />
                  </div>
                </TabPane>

                <TabPane tabId="4">
                  <div className="">
                    <TabPurchase SelectedItem={this.state.SelectedItem}></TabPurchase>
                  </div>
                </TabPane>

              </TabContent>
            </div>
          </div>
        )
      }else{
        return (
          <TabMaintenance
            usedFor='inUser'
            UserReducer={this.state.UserReducer} 
            SelectedItem={this.state.SelectedItem} 
          />
        )
      }
    }else{
      if(this.state.SelectedItem.IsInternalAsset){
        return this.renderActionButton('row hidden-md-down')
      }else{
        return (
          <TabMaintenance
            usedFor='inUser'
            UserReducer={this.state.UserReducer} 
            SelectedItem={this.state.SelectedItem} 
          />
        )
      }
    }
  }

  render() {
    if(this.state.SelectedItem === null) return(null)

    const isFromQR 		= this.props.isFromQR
    const SelectedItem 	= this.state.SelectedItem
    const isInternalAsset = SelectedItem.IsInternalAsset

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.closeModal} /*onEnter={this.willMount.bind(this)}*/ className="modal-lg">
        <ModalHeader toggle={this.props.closeModal}>{SelectedItem.Name}</ModalHeader>
        <ModalBody>
          {isFromQR && isInternalAsset ? this.renderDetailInformation() : null}
          {isFromQR && isInternalAsset ? this.renderActionButton(classnames('row m-top-15', {'hidden-lg-up' : isFromQR})) : null}
          <div className='row'>
            {isFromQR && isInternalAsset ? this.renderReservationField('hidden-lg-up') : null}
              <div className={classnames("col-lg-5", { 'hidden-md-down' : isFromQR && isInternalAsset})}>
                  <div className="col-md-12 hidden-lg-up">
                    <div className="list-separator">
                      <div className="item-inner">QR Code</div>
                    </div>
                    <div className="m-top-15">
                      <QRCode
                        value = {
                          JSON.stringify({
                            type : 'asset',
                            value : SelectedItem.Alias
                          })
                        }
                        logo = {Logo}
                        logoWidth = {50}
                        size = {150}
                        customSize = {'100%'}
                      />
                    </div>
                    <div className="cell-spacer"></div>
                  </div>
                  <div className="col-md-10 offset-md-1 col-lg-12 offset-lg-0">
                    <div className="list-separator hidden-lg-up">
                      <div className="item-inner">Asset Image</div>
                      </div>
                      <div className="m-top-15 hidden-lg-up"></div>
                      <Slider {...SliderSetting}>
                        {this.RenderImage()}
                      </Slider>
                      <div className="cell-spacer"></div>
                  </div>
                  {isInternalAsset ? this.renderReservationField('hidden-md-down') : null}
              </div>
              <div className={classnames("col-lg-7", { 'hidden-md-down' : (isFromQR && isInternalAsset)})}>
                <div className="list-separator">
                  <div className="item-inner">Asset Information</div>
                </div>
                  <ListGroup>
                    <ListGroupItem className="list-border-bottom">
                      <div className="col-md-4">
                        <strong className="spaceRRR">Asset</strong>
                      </div>
                      <div className="col-md-8">
                        <span>{SelectedItem.Name}</span>
                      </div>
                    </ListGroupItem>
                    <ListGroupItem className="list-border-bottom">
                      <div className="col-md-4">
                        <strong className="spaceRRR">Asset Alias</strong>
                      </div>
                      <div className="col-md-8">
                        <span>{SelectedItem.Alias}</span>
                      </div>
                    </ListGroupItem>
                      <ListGroupItem className="list-border-bottom">
                        <div className="col-md-4">
                          <strong className="spaceRRR">Tag</strong>
                        </div>
                        <div className="col-md-8">
                          <span>{SelectedItem.Tag ? SelectedItem.Tag : '-'}</span>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem className="list-border-bottom">
                        <div className="col-md-4">
                          <strong className="spaceRRR">Assigned</strong>
                        </div>
                        <div className="col-md-8">
                          <span>{SelectedItem.Owner.FirstName}</span>&nbsp;<span>{SelectedItem.Owner.LastName}</span>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem className="list-border-bottom">
                        <div className="col-md-4">
                          <strong className="spaceRRR">Status</strong>
                        </div>
                        <div className="col-md-8">
                          <span>{SelectedItem.Status.Name}</span>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem className="list-border-bottom">
                        <div className="col-md-4">
                          <strong className="spaceRRR">Type</strong>
                        </div>
                        <div className="col-md-8">
                          <span>{SelectedItem.Type.Name}</span>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem className="list-border-bottom">
                        <div className="col-md-4">
                          <strong className="spaceRRR">Site</strong>
                        </div>
                        <div className="col-md-8">
                          <span>{SelectedItem.Site.Name}</span>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem className="list-border-bottom">
                        <div className="col-md-4">
                          <strong className="spaceRRR">Location</strong>
                        </div>
                        <div className="col-md-8">
                          <span>{SelectedItem.Location.Name}</span>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem className="list-border-bottom">
                        <div className="col-md-4">
                          <strong className="spaceRRR">Max Days</strong>
                        </div>
                        <div className="col-md-8">
                          <span>{SelectedItem.MaxDay}</span>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem className="list-border-bottom">
                        <div className="col-md-12">
                          <strong className="spaceRRR">Description</strong>
                        </div>
                        <div className="col-md-12">
                          <span>{SelectedItem.Description}</span>
                        </div>
                      </ListGroupItem>
                      <ListGroupItem className="list-border-bottom hidden-md-down">
                        <div className="col-md-12">
                          <strong className="spaceRRR">QR Code</strong>
                        </div>
                        <div className="col-md-12 offset-md-4">
                          <QRCode
                            value = {
                              JSON.stringify({
                                type : 'asset',
                                value : SelectedItem.Alias
                              })
                            }
                            logo = {Logo}
                            logoWidth = {30}
                            customSize = {150}
                          />
                        </div>
                    </ListGroupItem>
                  </ListGroup>
              </div>
          </div>
          {this.renderDetailTab()}
        </ModalBody>
        <ModalFooter>
          <button type="button" onClick={()=>this.props.closeModal()} className="btn btn-danger">Close</button>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/Modal/ModalDetailAsset.js